<template>
  <div style="width:100%;">
    <v-card width="400" style="margin-left:auto;margin-right:auto;" outlined>
      <v-card-title>
        <h2>{{ $t("forgot_password.header") }}</h2>
      </v-card-title>
      <v-card-text>
          <p>{{ $t("forgot_password.header_description") }}</p>
        <v-form @submit="requestNewPassword">
          <v-text-field type="text" :label="$t('forgot_password.email')" v-model="email"></v-text-field>
          <v-btn type="submit" depressed>{{ $t("forgot_password.request_password") }}</v-btn>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="openLogin">{{ $t("forgot_password.or_want_to_login") }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { auth } from '../schmucklicloud';
import { Notifications } from '../notification';
export default {
    data() {
        return {
            email: ""
        }
    },
    methods: {
        async requestNewPassword(e) {
            e.preventDefault();
            var response = await auth.requestResetPassword(this.email);
            if (response.isOK) {
                this.$router.replace("/login");
                Notifications.show("An email has been sent with the link.");
            } else {
                Notifications.show(response.message);
            }
        },
        openLogin() {
            this.$router.replace("/login");
        }
    }
};
</script>

<style>
</style>